// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2o725","log":"ModalInventoryLogs_log__33HIl","date":"ModalInventoryLogs_date__2R0uE","userName":"ModalInventoryLogs_userName__2k7Bm"};